/* Shop All (/collections/all) — front-end behavior.
 *  1) S00 live countdown: rolling 24h window persisted to localStorage, ticks HH:MM:SS,
 *     resets to a fresh window on expiry. Not a static string.
 *  2) S03 "01" qty stepper: min 1, zero-padded display, writes name="quantity" for
 *     quick-add-ajax.js to submit. Minus disabled at 01.
 *  3) S04 CTA proxy: the styled [data-sa-fmm-open] buttons click the shipped Find-My-Match
 *     trigger ([data-fmm-open]) so the existing modal opens — no new quiz.
 */
(function () {
  'use strict';

  /* ---------- 1) Countdown ---------- */
  function initCountdown() {
    var els = document.querySelectorAll('[data-sa-countdown]');
    if (!els.length) return;

    // Deadline = last millisecond of the current calendar month in visitor's local time.
    // No localStorage — recomputed fresh each time.
    function monthEndDeadline() {
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999).getTime();
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    var deadline = monthEndDeadline();

    function tick() {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        // Month rolled over — recompute for the now-current month.
        deadline = monthEndDeadline();
        remaining = deadline - Date.now();
      }
      var totalSec = Math.floor(remaining / 1000);
      var days = Math.floor(totalSec / 86400);
      var h = Math.floor((totalSec % 86400) / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      var text = days >= 1
        ? days + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s)
        : pad(h) + ':' + pad(m) + ':' + pad(s);
      for (var i = 0; i < els.length; i++) { els[i].textContent = text; }
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------- 2) Qty steppers ---------- */
  function initSteppers() {
    var steppers = document.querySelectorAll('[data-sa-stepper]');
    Array.prototype.forEach.call(steppers, function (stepper) {
      var minus = stepper.querySelector('[data-sa-minus]');
      var plus = stepper.querySelector('[data-sa-plus]');
      var display = stepper.querySelector('[data-sa-display]');
      var input = stepper.querySelector('[data-sa-qty]');
      if (!minus || !plus || !display || !input) return;

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function render() {
        var q = parseInt(input.value, 10) || 1;
        if (q < 1) q = 1;
        input.value = String(q);
        display.textContent = pad(q);
        if (q <= 1) {
          minus.setAttribute('disabled', 'disabled');
        } else {
          minus.removeAttribute('disabled');
        }
      }

      minus.addEventListener('click', function () {
        var q = parseInt(input.value, 10) || 1;
        if (q > 1) { input.value = String(q - 1); render(); }
      });
      plus.addEventListener('click', function () {
        var q = parseInt(input.value, 10) || 1;
        input.value = String(q + 1);
        render();
      });

      render();
    });
  }

  /* ---------- 3) Find-My-Match proxy ---------- */
  function initQuizProxy() {
    var openers = document.querySelectorAll('[data-sa-fmm-open]');
    if (!openers.length) return;
    var realTrigger = document.querySelector('.shop-all [data-fmm-open]');
    if (!realTrigger) return;
    Array.prototype.forEach.call(openers, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        realTrigger.click();
      });
    });
  }

  function init() {
    initCountdown();
    initSteppers();
    initQuizProxy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
